import { TabWrapper, WidgetBodyWrapper, WidgetFooterWrapper, WidgetVisibleWrapper } from './styled'

import BalanceChecker from './balance-checker'
import { ButtonWrapper } from './button-wrapper/index'
import BuySellTab from './buy-sell-tab'
import { Index } from 'hooks/type-of-use-indices'
import { InputField } from './input-field'
import React from 'react'
import TokensReceivedSection from './tokens-received-section'

type Props = {
  indexInfo: Index
  finishedLoading: boolean
}

export const WidgetApp: React.FC<Props> = ({ indexInfo, finishedLoading }) => {
  return (
    <>
      <WidgetVisibleWrapper id="tour-demo-chart">
        <>
          <TabWrapper>
            <BuySellTab />
          </TabWrapper>
          <WidgetBodyWrapper>
            <InputField indexInfo={indexInfo} finishedLoading={finishedLoading} />
            <BalanceChecker />
            <TokensReceivedSection indexInfo={indexInfo} />
          </WidgetBodyWrapper>
        </>
        <WidgetFooterWrapper>
          <ButtonWrapper />
        </WidgetFooterWrapper>
      </WidgetVisibleWrapper>
    </>
  )
}
export default WidgetApp
